import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { BP_TABLET_MAX } from '../../../assets/styles/breakpoints';

export default styled.tr`
  background: ${COLOR_WHITE};
  &:first-child {
    td {
      &:first-child {
        border-top-left-radius: 0px;
      }
      &:last-child {
        border-top-right-radius: 0px;
      }
    }
  }
  &:last-child {
    td {
      &:first-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-left-radius: 12px;`)}
      }
      &:last-child {
        ${({ hasPagination }) => (hasPagination ? `` : `border-bottom-right-radius: 12px;`)}
      }
      &:after {
        display: none;
      }
    }
  }
  &:hover {
    cursor: pointer;
    td {
      background: #f8f8f9;
    }
  }
  td {
    height: 60px;
    text-align: center;
    position: relative;
    max-width: 200px;

    .detail-button {
      min-width: 100px;
      padding: 9px 27px 8px 27px;
    }

    a {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    a:hover {
      text-decoration: none;
    }

    &:after {
      content: '';
      position: absolute;
      bottom: 0px;
      height: 1px;
      width: 100%;
      background: rgba(47, 46, 65, 0.1);
      left: 0;
    }
    &:first-child {
      padding-left: 10px;
      a {
        padding-left: 22px;
      }

      &:after {
        right: 0px;
        left: auto;
      }
    }
    &:last-child {
      a {
        padding-right: 32px;
        text-align: right;
      }
      &:after {
        right: auto;
        left: 0px;
      }
    }
  }
  @media (max-width: ${BP_TABLET_MAX}px) {
    display: flex;
    margin-bottom: 16px;
    box-shadow: 0 8px 15px 0 rgba(47, 46, 65, 0.04);
    border-radius: 12px;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: center;
    td {
      max-width: 100%;
      width: 100%;
      padding: 0px 0px;
      &:after {
        display: none;
      }
      display: flex;
      flex-direction: row;

      a {
        justify-content: space-between;
        align-items: flex-start;
      }

      &:first-child {
        padding-left: 0;
        a {
          padding-top: 24px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
      &:last-child {
        padding-right: 0;
        a {
          padding-top: 8px;
          padding-bottom: 24px;
          padding-left: 16px;
          padding-right: 16px;
          width: 100%;
        }
      }
    }
  }
`;
